import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CMS_LIST_CONVERTER_TOKEN, CmsListConverter } from './cms-list/cms-list.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        cmsSearchFeature: {
          module: () => import('./cms-search.module').then((m) => m.CmsSearchModule),
          cmsComponents: ['content_list', 'job_search', 'result_item_certificates', 'result_item_clinical_changes',
            'result_item_certificates', 'result_item_content', 'result_item_faq', 'result_item_job', 'result_item_video',
            'result_item_document']
        },
      }
    }),
    {
      provide: CMS_LIST_CONVERTER_TOKEN,
      useExisting: CmsListConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        content_list: CMS_LIST_CONVERTER_TOKEN,
        job_search: CMS_LIST_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class CmsSearchFeatureModule {}
